import React, { Fragment } from 'react'

const RouteLoginConfirmation = () => (
  <Fragment>
    <h6>Account confirmation required</h6>
    <p>
      It looks like this is your first time signing in with FocusVision! We've
      sent instructions to your email to confirm your account.
    </p>
  </Fragment>
)

export default RouteLoginConfirmation



// WEBPACK FOOTER //
// ./src/routes/login/confirmation.js